module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validators),
      expression: "validators"
    }],
    staticClass: "validate form-control",
    attrs: {
      "data-vv-as": _vm.field.description.replace(/\./g, ''),
      "id": _vm.field.name,
      "name": _vm.field.name,
      "type": _vm.field.type,
      "placeholder": _vm.field.placeholder,
      "minlength": _vm.field.minSize,
      "maxlength": _vm.field.maxSize,
      "readonly": _vm.locked
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.input
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ce95cc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/TextRender.vue
// module id = 1550
// module chunks = 1